// import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import swal from "sweetalert2";
import { AuthGuardService } from "./auth-guard.service";
import { DataService } from "./data.service";

const DEFAULT_UNAUTHENTICATED_MESSAGE =
  "Your session has expired. Please login again.";
const DEFAULT_FORBIDDEN_MESSAGE =
  "You are not authorized to perform this action.";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    public dataService: DataService,
    public router: Router,
    private authGuard: AuthGuardService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authToken = this.dataService.getToken();
    const isValidTone = this.authGuard.validateToken(authToken);

    req = req.clone({
      setHeaders: {
        // 'Content-Type': 'application/json; charset=utf-8',
        Accept: "application/json",
        Authorization: `${authToken}`,
      },
    });

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // console.log('event', event);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.handleUnauthenticated(error);
        } else if (error.status === 403) {
          this.handleForbidden(error);
        }

        return throwError(error);
      })
    );
  }

  private handleUnauthenticated(error: HttpErrorResponse): void {
    const message = error.error?.message || DEFAULT_UNAUTHENTICATED_MESSAGE;

    localStorage.clear();

    swal
      .fire({
        title: "Authentication Failed",
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-fill btn-rose",
        },
        icon: "error",
      })
      .then(() => {
        this.router.navigate(["/"]);
      });
  }

  private handleForbidden(error: HttpErrorResponse): void {
    const message = error.error?.message || DEFAULT_FORBIDDEN_MESSAGE;

    swal
      .fire({
        title: "Access Denied",
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-fill btn-rose",
        },
        icon: "error",
      })
      .then(() => {
        this.router.navigate(["/"]);
      });
  }
}
